<app-header></app-header>

<div class="share-location-container">
  <h2 class="title">SOS Live Tracking</h2>

  <!-- Error banner -->
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <!-- Tracking ended banner -->
  <div *ngIf="isEnded" class="alert alert-warning">
    {{ infoMessage || 'Tracking has ended.' }}
    <!-- AC-4674: a newer SOS from the sender replaced this one -->
    <a *ngIf="newSessionUrl" class="new-session-link" [href]="newSessionUrl">Open the new live map</a>
  </div>

  <!-- AC-4621: sender's phone stopped sharing (app closed, phone off, no signal) -->
  <div *ngIf="senderSilentSince && !isEnded && !connectionTerminated" class="alert alert-danger" style="font-weight:500;">
    {{ agentName }}'s phone stopped sharing its location at {{ senderSilentSince | date:'shortTime' }}.
    Their app may be closed or offline. Please call {{ agentName }} to check they're OK.
  </div>

  <!-- Connection terminated banner -->
  <div *ngIf="connectionTerminated && !isEnded" class="alert alert-danger" style="font-weight:500;">
    Connection with {{ viewerRole === 'responder' ? agentName : 'an EC' }} terminated. Please call 911.
  </div>

  <!-- GPS denied banner (responder only) -->
  <div *ngIf="locationDenied && viewerRole === 'responder' && !isEnded"
       class="location-denied-banner"
       (click)="onRetryLocation()" role="button">
    <span class="location-icon">📍</span>
    <span>
      <strong>Location is off.</strong>
      {{ retryingLocation ? 'Asking for your location...' : 'Tap to share your location with ' + agentName + '.' }}
    </span>
  </div>

  <!-- Waiting hint  -->
  <div *ngIf="!errorMessage && !hasReceivedFirstUpdate && !isEnded && !locationDenied" class="alert alert-secondary">
    Waiting for live location updates...
  </div>

  <!-- Map + desktop side panel wrapper -->
  <div class="map-shell" *ngIf="!errorMessage">

    <!-- Map -->
    <div class="map-container">
      <div
        class="map-wrapper"
        leaflet
        [leafletOptions]="options"
        (leafletMapReady)="onMapReady($event)">
      </div>
      <button class="recenter-btn" (click)="onRecenter()" title="Show all participants">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/>
          <line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/>
        </svg>
      </button>
    </div>

    <!-- Desktop panel (visible only on desktop via CSS) -->
    <div class="side-panel">
      <div class="panel-header">
        <div class="panel-title">People in this SOS</div>
        <div class="panel-directions-hint">Tap any pin on the map to see instant directions</div>
        <div class="panel-subtitle">
          {{ participantsCount }} participant{{ participantsCount === 1 ? '' : 's' }}
        </div>
      </div>

      <div class="panel-body">
        <div class="participant-list">
          <div class="participant-row" *ngFor="let p of participantsUi">
              <div class="dot"
       [class.sender]="p.role==='sender'"
       [class.r1]="p.role==='responder' && p.responderNo===1"
       [class.r2]="p.role==='responder' && p.responderNo===2"
       [class.r3]="p.role==='responder' && p.responderNo===3"
       [class.r4]="p.role==='responder' && p.responderNo===4"
       [class.r5]="p.role==='responder' && p.responderNo===5"
       [style.background]="p.colorHex || null">
  </div>

            <div class="name">
              {{ p.label || p.displayName }}
              <div class="ec-status" *ngIf="p.role === 'responder'">
                <span class="status-indicator" [class.waiting]="p.connectionStatus === 'waiting'"
                      [class.connected]="p.connectionStatus === 'connected'"
                      [class.disconnected]="p.connectionStatus === 'disconnected'"></span>
                <span>{{ p.connectionStatus === 'waiting' ? 'Waiting to join' :
                         p.connectionStatus === 'connected' ? 'Connected' : 'Disconnected' }}</span>
              </div>
              <!-- AC-4683 -->
              <div class="sender-status" *ngIf="p.role === 'sender' && senderStatusText" [class.stale]="senderStatusStale">
                {{ senderStatusText }}
              </div>
              <div class="ec-status" *ngIf="p.role === 'sender' && isEnded && !isExpired">
                <span class="status-indicator connected"></span>
                <span>Safe now</span>
              </div>
            </div>

            <div class="distance" *ngIf="p.role==='responder' && p.distanceText">
              {{ p.distanceText }}
            </div>
          </div>
        </div>

        <div class="panel-actions">
          <button class="btn btn-danger w-100"
                  *ngIf="canMarkSafe"
                  (click)="onMarkSafe()">
            Mark Safe
          </button>

          <button class="btn btn-outline-danger w-100 mt-2"
                  *ngIf="canCancelSos"
                  (click)="onCancelSos()">
            Cancel SOS
          </button>

          <!-- <button class="btn btn-secondary w-100 mt-2"
                  *ngIf="canClose"
                  (click)="onClose()">
            Close
          </button> -->
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Mobile panel — always visible -->
<div class="mobile-panel" *ngIf="!errorMessage">
  <div class="mobile-panel-header">
    <div class="mp-title">People in this SOS</div>
    <div class="panel-directions-hint">Tap any pin on the map to see instant directions</div>
    <div class="mp-subtitle">
      {{ participantsCount }} participant{{ participantsCount === 1 ? '' : 's' }}
    </div>
  </div>

  <div class="mobile-panel-body">

    <div class="participant-list">
      <div class="participant-row" *ngFor="let p of participantsUi">
         <div class="dot"
       [class.sender]="p.role==='sender'"
       [class.r1]="p.role==='responder' && p.responderNo===1"
       [class.r2]="p.role==='responder' && p.responderNo===2"
       [class.r3]="p.role==='responder' && p.responderNo===3"
       [class.r4]="p.role==='responder' && p.responderNo===4"
       [class.r5]="p.role==='responder' && p.responderNo===5"
       [style.background]="p.colorHex || null">
  </div>
        <div class="name">
          {{ p.label || p.displayName }}
          <div class="ec-status" *ngIf="p.role === 'responder'">
            <span class="status-indicator" [class.waiting]="p.connectionStatus === 'waiting'"
                  [class.connected]="p.connectionStatus === 'connected'"
                  [class.disconnected]="p.connectionStatus === 'disconnected'"></span>
            <span>{{ p.connectionStatus === 'waiting' ? 'Waiting to join' :
                     p.connectionStatus === 'connected' ? 'Connected' : 'Disconnected' }}</span>
          </div>
          <!-- AC-4683 -->
          <div class="sender-status" *ngIf="p.role === 'sender' && senderStatusText" [class.stale]="senderStatusStale">
            {{ senderStatusText }}
          </div>
        </div>

        <div class="distance" *ngIf="p.role==='responder' && p.distanceText">
          {{ p.distanceText }}
        </div>
      </div>
    </div>

    <div class="panel-actions">
      <button class="btn btn-danger w-100"
              *ngIf="canMarkSafe"
              (click)="onMarkSafe(); $event.stopPropagation()">
        Mark Safe
      </button>

      <button class="btn btn-outline-danger w-100 mt-2"
              *ngIf="canCancelSos"
              (click)="onCancelSos(); $event.stopPropagation()">
        Cancel SOS
      </button>

      <!-- <button class="btn btn-secondary w-100 mt-2"
              *ngIf="canClose"
              (click)="onClose(); $event.stopPropagation()">
        Close
      </button> -->
    </div>

  </div>
</div>

<!-- Reconnecting banner (auto-retry in progress, no user action needed yet) -->
<div *ngIf="showReconnectingBanner && !showReconnectDialog && !isEnded" class="alert alert-warning" style="text-align:center;font-weight:500;">
  Reconnecting... please wait.
</div>

<!-- Reconnect dialog (shown only when auto-retry has fully given up) -->
<div class="reconnect-overlay" *ngIf="showReconnectDialog && !isEnded">
  <div class="reconnect-sheet">
    <div class="reconnect-icon">⚠️</div>
    <h3>Connection Lost</h3>
    <p>Connection with <strong>{{ viewerRole === 'responder' ? agentName : 'an EC' }}</strong> was lost. Reconnect?</p>
    <button class="btn btn-danger w-100" (click)="onReconnectYes()">Yes, Reconnect</button>
    <button class="btn btn-outline-secondary w-100 mt-2" (click)="onReconnectNo()">No, Terminate</button>
  </div>
</div>

<!-- Location instructions modal -->
<div class="location-instructions-overlay" *ngIf="showLocationInstructions" (click)="onHideInstructions()">
  <div class="location-instructions-sheet" (click)="$event.stopPropagation()">
    <button class="instructions-close" (click)="onHideInstructions()">✕</button>
    <h3>How to share your location</h3>
    <p>Location is blocked for this page. Allow it, then reload so {{ agentName }} can see you on the map.</p>
    <ng-container [ngSwitch]="locationHelpBrowser">
      <ng-container *ngSwitchCase="'samsung'">
        <p class="instructions-heading">Samsung Internet</p>
        <ol>
          <li>Open your phone's <strong>Settings</strong> → <strong>Apps</strong> → <strong>Samsung Internet</strong> → <strong>Permissions</strong> → <strong>Location</strong> → <strong>Allow only while using the app</strong>.</li>
          <li>In Samsung Internet, tap <strong>☰</strong> (bottom right) → <strong>Settings</strong> → <strong>Sites and downloads</strong> → <strong>Site permissions</strong> → <strong>Location</strong>, and remove the block for this site.</li>
          <li>Make sure <strong>Location</strong> is on in the quick settings panel (swipe down from the top).</li>
          <li>Tap <strong>Reload page</strong> below and choose <strong>Allow</strong> when asked.</li>
        </ol>
      </ng-container>
      <ng-container *ngSwitchCase="'chrome-android'">
        <p class="instructions-heading">Chrome on Android</p>
        <ol>
          <li>Open your phone's <strong>Settings</strong> → <strong>Apps</strong> → <strong>Chrome</strong> → <strong>Permissions</strong> → <strong>Location</strong> → <strong>Allow only while using the app</strong>.</li>
          <li>In Chrome, tap the icon to the left of the address bar → <strong>Permissions</strong> (or <strong>Site settings</strong>) → <strong>Location</strong> → <strong>Allow</strong>.</li>
          <li>Make sure <strong>Location</strong> is on in the quick settings panel (swipe down from the top).</li>
          <li>Tap <strong>Reload page</strong> below and choose <strong>Allow</strong> when asked.</li>
        </ol>
      </ng-container>
      <ng-container *ngSwitchCase="'android'">
        <p class="instructions-heading">Android</p>
        <ol>
          <li>Open your phone's <strong>Settings</strong> → <strong>Apps</strong> → the browser you're using → <strong>Permissions</strong> → <strong>Location</strong> → <strong>Allow only while using the app</strong>.</li>
          <li>In the browser, open the site settings or permissions for this page and allow <strong>Location</strong>.</li>
          <li>Make sure <strong>Location</strong> is on in the quick settings panel (swipe down from the top).</li>
          <li>Tap <strong>Reload page</strong> below and choose <strong>Allow</strong> when asked.</li>
        </ol>
      </ng-container>
      <ng-container *ngSwitchCase="'safari-ios'">
        <p class="instructions-heading">Safari on iPhone</p>
        <ol>
          <li>Open <strong>Settings</strong> → <strong>Privacy &amp; Security</strong> → <strong>Location Services</strong>: turn it on, then tap <strong>Safari Websites</strong> → <strong>While Using the App</strong>.</li>
          <li>Back in Safari, tap <strong>aA</strong> (or the page menu) in the address bar → <strong>Website Settings</strong> → <strong>Location</strong> → <strong>Allow</strong> (or <strong>Ask</strong>).</li>
          <li>Tap <strong>Reload page</strong> below and choose <strong>Allow</strong> when asked.</li>
        </ol>
      </ng-container>
      <ng-container *ngSwitchCase="'chrome-ios'">
        <p class="instructions-heading">Chrome on iPhone</p>
        <ol>
          <li>Open <strong>Settings</strong> → <strong>Privacy &amp; Security</strong> → <strong>Location Services</strong>: make sure it's on.</li>
          <li>Open <strong>Settings</strong> → <strong>Apps</strong> → <strong>Chrome</strong> → <strong>Location</strong> → <strong>While Using the App</strong>.</li>
          <li>Tap <strong>Reload page</strong> below and choose <strong>Allow</strong> when asked.</li>
        </ol>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ol>
          <li>Tap the <strong>site settings</strong> or lock icon in your browser's address bar.</li>
          <li>Find <strong>Location</strong> and select <strong>Allow</strong>.</li>
          <li>Make sure location is turned on for your device and for this browser in your phone's settings.</li>
          <li>Tap <strong>Reload page</strong> below.</li>
        </ol>
      </ng-container>
    </ng-container>
    <button class="btn btn-primary w-100 mt-3" (click)="onReloadForLocation()">Reload page</button>
    <button class="btn btn-link w-100 mt-1" (click)="onHideInstructions()">Not now</button>
  </div>
</div>

<app-footer [rescueApp]="isRescueLink"></app-footer>
